'use strict';

require('./curry.js');
require('./chunk-ba04ad2f.js');
require('./chunk-d7703e54.js');
require('./variadic.js');
var compose = require('./compose.js');
require('./_append.js');
require('./append.js');
require('./flip.js');
var __chunk_3 = require('./chunk-56a5551b.js');
var __chunk_4 = require('./chunk-e6d921c6.js');
var __chunk_5 = require('./chunk-ac19a55d.js');
var concat = require('./concat.js');

/**
 * Flattens any strings in the list of `as`.
 *
 * @private
 */

function flattenStrings(as) {
  if (__chunk_5.isArrayOfStrings(as)) {
    return concat(as);
  } else if (__chunk_4.isArray(as)) {
    return as.map(flattenStrings);
  } else {
    return as;
  }
}

function concatMap(f, as) {
  var bs = Array.from(as).map(compose(flattenStrings, f));
  var cs = bs.length > 0 ? bs : as;
  return __chunk_3.concatWith(__chunk_5.mempty(cs), bs);
}

module.exports = concatMap;
